import { render, staticRenderFns } from "./UsageDispensingShiptech.vue?vue&type=template&id=4539ed3e"
import script from "./UsageDispensingShiptech.vue?vue&type=script&lang=js"
export * from "./UsageDispensingShiptech.vue?vue&type=script&lang=js"
import style0 from "./UsageDispensingShiptech.vue?vue&type=style&index=0&id=4539ed3e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports